// @ts-nocheck

import HomeOutlined from '@ant-design/icons/HomeOutlined';
import BranchesOutlined from '@ant-design/icons/BranchesOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import ApiOutlined from '@ant-design/icons/ApiOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import ToTopOutlined from '@ant-design/icons/ToTopOutlined'

export default {
  HomeOutlined,
BranchesOutlined,
LineChartOutlined,
CloudUploadOutlined,
MessageOutlined,
ApiOutlined,
SettingOutlined,
ProfileOutlined,
ToTopOutlined
}
    